/**
 * The plan list prices the explainer uses (monthly, USD cents). They mirror
 * jobseeker-be/src/licensing/plans.ts; commission is earned on the list price.
 */
export const PLAN_PRICES = [
  { key: 'starter', label: 'Starter', cents: 1900 },
  { key: 'pro', label: 'Pro', cents: 6900 },
  { key: 'power', label: 'Power', cents: 9900 },
] as const

/** What one payment looks like with a coupon: the customer pays the rest, the partner earns on the list price. */
export function split(listCents: number, discountPct: number, commissionPct: number) {
  const discountCents = Math.round((listCents * discountPct) / 100)
  return {
    listCents,
    discountCents,
    paidCents: listCents - discountCents,
    commissionCents: Math.round((listCents * commissionPct) / 100),
  }
}

/** commission % = partner max % − coupon %, never below 0. */
export function commissionFor(maxPct: number, discountPct: number): number {
  return Math.max(0, Math.round((maxPct - discountPct) * 100) / 100)
}
